import { ECompanyBalanceItem, ICompanyBalanceAmount, IUserInitialState } from './interface'

export const BALANCE_INITIAL_STATE: ICompanyBalanceAmount = { amount: 0, currency: 'MXN' }

export const COMPANY_BALANCE_INITIAL_STATE: Record<ECompanyBalanceItem, ICompanyBalanceAmount[]> = {
  available: [BALANCE_INITIAL_STATE],
  gateway: [BALANCE_INITIAL_STATE],
  pending: [BALANCE_INITIAL_STATE],
  retained: [BALANCE_INITIAL_STATE],
  retention_amount: [BALANCE_INITIAL_STATE],
  target_collateral_amount: [BALANCE_INITIAL_STATE],
  target_retention_amount: [BALANCE_INITIAL_STATE],
  temporarily_retained: [BALANCE_INITIAL_STATE]
}

export const HTTP_RESPONSE_CODE_200 = { max: 299, min: 200 }
export const INITIAL_STATE_REDUCERS = { data: [], error: {}, isLoading: false }
export const RECORD_COUNT_HEADER = 'x-record-count'

export const USER_INITIAL_STATE: IUserInitialState = {
  entities: [],
  userActivitiesPermissionsByEntity: [],
  userId: '',
  userType: ''
}
